import { Link } from 'react-router-dom';
import { games } from '../data/games';
import { useLadderState } from '../hooks/useLadderState';
import FavoriteGamesList from './FavoriteGamesList';
import HomeMessage from './HomeMessage';
import ScoresSection from './ScoresSection';
import FeaturedSection from './FeaturedSection';

function Home() {
  // Latched once per page load - see useLadderState. Computed here rather than
  // inside each consumer so the message block and the hero can't disagree
  // about which state the visitor is in.
  const ladderState = useLadderState();

  // Everyone except the people already sharing. Hidden while the state is
  // still unknown, so it doesn't appear and then vanish on the same load.
  const showHero = ladderState !== null && ladderState <= 4;

  return (
    <div className="max-w-4xl mx-auto px-1">

      <FavoriteGamesList />

      {/* One message, chosen by how far along the visitor is. Deliberately
          unpanelled - see HomeMessage. */}
      <HomeMessage state={ladderState} />

      {/* Sharing lives inside this block now, behind its "Invite" link. */}
      <ScoresSection />

      <FeaturedSection showHero={showHero} />

      <Link
        to="/all"
        className="mx-1 mb-3 flex items-center justify-center gap-2 transition-opacity duration-150 hover:opacity-80"
      >
        <span className="font-semibold text-nlg-text">Browse all</span>
        <span className="font-display font-black text-3xl leading-none text-nlg-gold">{games.length}</span>
        <span className="font-semibold text-nlg-text">games</span>
        <img src="/img/right_arrow.png" alt="" className="w-4 h-4" />
      </Link>

    </div>
  );
}

export default Home;
